import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { Main } from 'Containers/';
import { successToast, toastType, errorToast } from 'Common/ToastHelper';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';
import { getNotifications } from 'Common/UI/state/selectors';

import { AeriesManualSync } from './AeriesManualSync';
import {
  SuccessNotificationTitle,
  FailedNotificationTitle,
} from '../../helpers/Constants';
import * as Selectors from '../../state/selectors';
import * as Actions from '../../state/actions';

export class AeriesImportStepContainer extends Component {
  static stepInfo = {
    icon: 'file text',
    title: 'Manual Import',
    description: 'Import your data.',
  };

  componentDidUpdate(prevProps) {
    const {
      setManualSyncComplete,
      setManualSyncLoading,
      loading,
      notifications,
      setStepCompleted,
      clearManualSyncErrors,
    } = this.props;

    if (errorToast(this.props, prevProps, 'errors')) {
      clearManualSyncErrors();
      setManualSyncLoading(false);
    }

    const firstTitle = get(notifications, '[0].Title');

    if (
      loading &&
      get(notifications, 'length', 0) >
        get(prevProps, 'notifications.length', 0) &&
      (firstTitle === SuccessNotificationTitle ||
        firstTitle === FailedNotificationTitle)
    ) {
      setManualSyncComplete(true);
      setManualSyncLoading(false);

      if (firstTitle !== FailedNotificationTitle) {
        setStepCompleted(true);
      }
    }
  }

  getMainProps = () => {
    const {
      loading,
      goToPreviousStep,
      getManualSync,
      setYesNoDialogProps,
    } = this.props;

    const mainProps = {
      toolbox: {
        shown: true,
        backButtonProps: {
          shown: true,
          callback: goToPreviousStep,
        },
        rightButtons: [
          {
            content: 'Import',
            loading: loading,
            disabled: loading,
            onClick: async () => {
              setYesNoDialogProps({
                showDialog: true,
                title: 'Import',
                question:
                  "This import may have adverse effects on on your current data. Are you sure you'd like to import?",
                yesCallback: () => {
                  getManualSync();
                  successToast(toastType.success, 'Manual Import has started');
                },
                noCallback: () => {},
                cancelCallback: () => {},
              });
            },
          },
        ],
      },
    };

    return mainProps;
  };

  render() {
    const { manualSyncComplete, loading } = this.props;

    return (
      <Main {...this.getMainProps()}>
        <AeriesManualSync isComplete={manualSyncComplete} loading={loading} />
      </Main>
    );
  }
}

const mapStateToProps = (state) => {
  const manualSync = Selectors.getManualSync(state);
  return {
    manualSyncComplete: manualSync.manualSyncComplete,
    loading: manualSync.loading,
    errors: manualSync.errors,
    notifications: getNotifications(state),
  };
};

const mapDispatchToProps = { ...Actions, setYesNoDialogProps };

export const AeriesImportStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(AeriesImportStepContainer);



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/components/AeriesImportStep/AeriesImportStep.js